import React, { createContext, useReducer } from 'react';
import appReducer from './AppReducer';

export const LOGOUT = 'LOGOUT';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';

export const ADMIN_USER = 2
export const PROVINCE_USER = 1;
export const COMPANY_USER = 0;

const token = localStorage.getItem('token');

const initialState = {
  user: token || null,
};

export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  function authentication(token, refresh, user) {
    localStorage.setItem('token', token);
    localStorage.setItem('refresh', refresh);
    localStorage.setItem('user_full_name', user?.full_name);
    localStorage.setItem('user_type', user?.user_type);
    localStorage.setItem('province_id', user?.province_id);
    localStorage.setItem('union_id', user?.union_id);

    dispatch({
      type: AUTH_SUCCESS,
      payload: { user: token },
    });
  }

  function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    localStorage.removeItem('user_full_name');
    localStorage.removeItem('user_type');
    localStorage.removeItem('province_id');
    localStorage.removeItem('union_id');

    dispatch({
      type: LOGOUT,
    });
  }

  return (
    <GlobalContext.Provider
      value={{
        user: state.user,
        authentication,
        logout,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};